"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var FlagDE = function (_a) {
    var className = _a.className;
    return (react_1.default.createElement("svg", { className: className, height: '1em', viewBox: '0 0 24 24', width: '1em', xmlns: 'http://www.w3.org/2000/svg' },
        react_1.default.createElement("title", null, "Flag of Germany"),
        react_1.default.createElement("g", { fill: 'none', fillRule: 'evenodd' },
            react_1.default.createElement("path", { d: 'M22 9.594V6c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v3.594h20z', fill: '#000' }),
            react_1.default.createElement("path", { d: 'M3 19h18c.55 0 1-.45 1-1v-3.594H2.2c-.071 0-.133.027-.2.041V18c0 .55.45 1 1 1', fill: '#FFDC40' }),
            react_1.default.createElement("path", { d: 'M2.2 14.406H22V9.594H2.01L2 9.595v4.81l.01.001h.19z', fill: '#EA1C35' }),
            react_1.default.createElement("path", { d: 'M0 0h24v24H0z' }))));
};
exports.default = FlagDE;
